// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"94":"1e4e1fbf61730d0bd584","724":"e7f2c6e6471b1be4331e"}[chunkId] + ".js";
};